import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Card, CardActions, CardContent, Grid, Typography } from "@mui/material";
import msalInstance from "dev-auth";

export function SignOutPage() {
  const navigate = useNavigate();

  async function signOutHandler() {
    await msalInstance.logoutRedirect();
  }

  return (
    <>
      <Grid
        container
        style={{ height: "100vh" }}
        sx={{
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Grid size="auto">
          <Box
            sx={{
              maxWidth: 450,
              textAlign: "center",
            }}
          >
            <Card>
              <CardContent>
                <Typography variant="h5" component="div" sx={{ padding: 2 }}>
                  Are you sure you want to sign out?
                </Typography>
                <Typography variant="body1" component="div">
                  Clicking <b>Sign out</b> will clear out cookies and log you out on this device.
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: "center" }}>
                <Button variant="contained" onClick={signOutHandler}>
                  Sign Out
                </Button>
                <Button onClick={() => navigate(-1)}>No I want to stay!</Button>
              </CardActions>
            </Card>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
